import React, { useEffect, useState } from "react";
import useAPI from "hooks/useAPI";
import moment from "moment";

const emptyForm = { code: "", percentage: "", expires: "", maxUses: "" };

const DiscountCodes = () => {
  const [discountCodes, setDiscountCodes] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const { API } = useAPI({});

  useEffect(() => {
    getAndSetDiscountCodes();
  }, []);

  const getAndSetDiscountCodes = async () => {
    const data = await API.get(`/admin/discount-codes`);
    setDiscountCodes(data?.discountCodes || []);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this discount code?")) return;
    await API.del(`/admin/discount-codes/${id}`);
    await getAndSetDiscountCodes();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const res = await API.post(`/admin/discount-codes`, {
        code: form.code,
        percentage: Number(form.percentage),
        expires: form.expires,
        maxUses: form.maxUses !== "" ? Number(form.maxUses) : null,
      });
      if (res?.error) {
        setError(res.error);
      } else {
        setForm(emptyForm);
        await getAndSetDiscountCodes();
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mx-auto py-8">
      <h1>Discount Codes</h1>

      <form onSubmit={handleSubmit} className="mt-6 mb-10 p-6 border rounded-xl max-w-2xl">
        <h2 className="text-lg font-semibold mb-4">Create New Code</h2>
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Code</label>
            <input
              name="code"
              value={form.code}
              onChange={handleChange}
              placeholder="e.g. TOL50OFF"
              required
              className="border rounded px-3 py-2 uppercase"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Percentage (%)</label>
            <input
              name="percentage"
              type="number"
              min="1"
              max="100"
              value={form.percentage}
              onChange={handleChange}
              placeholder="e.g. 50"
              required
              className="border rounded px-3 py-2"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Expires</label>
            <input
              name="expires"
              type="date"
              value={form.expires}
              onChange={handleChange}
              required
              className="border rounded px-3 py-2"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Max Uses <span className="text-gray-400 font-normal">(leave blank = unlimited)</span></label>
            <input
              name="maxUses"
              type="number"
              min="1"
              value={form.maxUses}
              onChange={handleChange}
              placeholder="unlimited"
              className="border rounded px-3 py-2"
            />
          </div>
        </div>
        {error && <p className="mt-3 text-red-500 text-sm">{error}</p>}
        <button
          type="submit"
          disabled={saving}
          className="mt-4 bg-black text-white px-6 py-2 rounded-lg disabled:opacity-50"
        >
          {saving ? "Creating..." : "Create Code"}
        </button>
      </form>

      <table className="mirum-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Percentage</th>
            <th>Expires</th>
            <th>Max Uses</th>
            <th>Used</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {discountCodes.map((dc) => (
            <tr key={dc._id}>
              <td>{dc.code}</td>
              <td>{dc.percentage}%</td>
              <td>{moment(dc.expires).format("DD/MM/YYYY")}</td>
              <td>{dc.maxUses === undefined ? "1 (legacy)" : dc.maxUses === null ? "unlimited" : dc.maxUses}</td>
              <td>{dc.usedCount || 0}</td>
              <td>{dc.status}</td>
              <td>
                <button
                  onClick={() => handleDelete(dc._id)}
                  className="text-red-500 text-sm hover:underline"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DiscountCodes;
